module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.559e978f.woff2";